module.exports = __webpack_public_path__ + "assets/img/warning.f8844dab.svg";